import styled from 'styled-components';

export const LineArrowSvg = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const ArrowSvg = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% ;
    z-index: 10;
    pointer-events: none;
    background: transparent;
`;
